export default {
	attendance: "Attendance",
	inProgress: "In Progress",
	selectConsultant: "Select Consultant",
	searchConsultant: "Search person for consultation",
	typeToSearch: "Type to search consultants",
	noConsultantsFound: "No consultants found",
	changeConsultant: "Change",
	loadingHistory: "Loading history...",
	noHistoryFound: "No history found for this consultant",
	errorLoadingHistory: "Error loading consultant history",
	mediumName: "Medium",
	ticketAssignedSuccess: "Ticket assigned successfully!",
	consultationFinishedSuccess: "Consultation finished successfully!",
	ticketCancelledSuccess: "Ticket cancelled successfully!",
	ticketDeletedSuccess: "Ticket deleted successfully!",
	errorLoadingRitual: "Error loading ritual information",
	ritualNotAvailable: "This ritual is not available for ticket distribution",
	errorLoadingConsultants: "Error loading consultants",
	errorCreatingTicket: "Error creating attendance ticket",
	consultantAlreadyHasTicket: "This consultant already has an active ticket in this ritual",
	consultantHasCancelledTicket: "This consultant has a cancelled ticket in this ritual",
	ticketSlotOccupied: "This ticket position is already occupied",
	consultantInfo: "Consultant Information",
	ticketDetails: "Ticket Details",
	consultationTime: "Consultation Time",
	viewProfile: "View Profile",
	finishConsultation: "Finish Consultation",
	cancelTicket: "Cancel Ticket",
	deleteTicket: "Delete Ticket",
	status: {
		pending: "Pending",
		in_progress: "In Progress",
		completed: "Completed",
		cancelled: "Cancelled",
	},
	confirmCancel: "Confirm Cancellation",
	confirmCancelMessage: "Are you sure you want to cancel this ticket? The consultant will be blocked in this ritual.",
	confirmDelete: "Confirm Deletion",
	confirmDeleteMessage: "Are you sure you want to delete this ticket? The consultant will be able to get a new ticket.",
	cardInfo: "Card / Medium · Guide",
	addTicket: "Add",
	selectConsultantFirst: "Select a consultant first",
	cardFull: "This card is full",
	onlyDuringInProgress: "Available only when the ritual is in progress",
	noTicketsYet: "No tickets distributed yet",
	noAttendanceCards: "No attendance cards configured for this ritual type",
	errorLoadingCards: "Error loading attendance cards",
	showNames: "Show names",
	hideNames: "Hide names",
	hasReservation: "Guaranteed reservation",
	totalTickets: "Tickets",
	pendingCount: "Pending",
	alreadyHasTicket: "This person already has a ticket in this ritual",
	assignTicket: "Assign Ticket",
	clickToDeselect: "Click to deselect",
	clickToSelect: "Click to select position",
	createNewConsultant: "Register New Person",
	errorLoadingConsultant: "Error loading consultant",
	noActiveRitual: "No ritual in progress at the moment",
	noAttendanceCardsHint: "Check if the ritual type has linked attendance types in the settings.",
	selected: "Selected",
	preSenha: {
		title: "Pre-queue number",
		called: "Number {number} called",
		resetSuccess: "Pre-queue number reset",
		errorCalling: "Error calling pre-queue number",
		errorResetting: "Error resetting pre-queue number",
	},
};
